import { components } from "@certn/api/generated-schemas/applicant-portal";
import { formatDate } from "@certn/utils";
import { useTranslation } from "react-i18next";

import { BaseCard } from "./BaseCard";

interface Props {
  caseInstance: components["schemas"]["CompleteCaseList"];
}

export function DeclinedCard(props: Props) {
  const { caseInstance } = props;
  const { t } = useTranslation();

  const declinedDate = caseInstance.logs?.findLast(
    ({ additional_data }) => additional_data?.event === "APPLICANT_DECLINED"
  )?.timestamp;

  return (
    <BaseCard
      title={caseInstance.customer_name}
      type="archived"
      tagText={t("Archived")}
      statusText={`${t("Cancelled")} ${formatDate(declinedDate ?? "", "PP")}`}
      variant="historyCard"
      shortID={caseInstance.short_id}
    />
  );
}
